import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="drawer-trigger"
export default class extends Controller {
  static values = {
    id: String,
    url: String,
    reset: { type: Boolean, default: true },
  };

  open() {
    const el = document.getElementById(this.idValue);
    if (!el) return;
    el.dispatchEvent(
      new CustomEvent("drawer:open", {
        bubbles: true,
        detail: { src: this.hasUrlValue ? this.urlValue : null, reset: this.resetValue },
      }),
    );
  }

  close() {
    const el = document.getElementById(this.idValue);
    if (!el) return;
    el.dispatchEvent(new CustomEvent("drawer:close", { bubbles: true }));
  }
}
